import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  MainBlock,
  BodyBlock,
  InputBody,
} from '../Activation/styles/ActivationPageStyles';
import {
  InputTitle,
  InputBlock,
  PINCodeBlock,
  PINCodeText,
  TextBlock,
  ReissueLink,
  ErrorMessage,
} from './styles/DeviceAuthPageStyles';
import { UpdateButton } from '../../styles/common/Dialog';
import DeviceAuthTitleBar from './DeviceAuthTitleBar';
import PINInput from './PINInput';
import ConfirmationDialog from '../Parts/ConfirmationDialog';
import ColorSF2 from '../../styles/common/ColorSF2';
import checkDeviceAuthCode from '../../actions/api/deviceAuth/checkDeviceAuthCode';
import { consolelog } from '../../lib/tools';
import UserPrompt from '../UserPrompt';
import { COOKIE_KEYS, PIN_CODE_LENGTH } from '../../lib/constants';
import reissueDeviceAuthCode from '../../actions/api/deviceAuth/reissueDeviceAuthCode';

const DeviceAuthPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiToken = useSelector(state => state.main.apiToken);
  const isDeviceAuthFailed = useSelector(
    state => state.deviceAuth.isDeviceAuthFailed,
  );

  const [enteredDeviceAuthCode, setEnteredDeviceAuthCode] = useState('');
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [, setCookie] = useCookies([COOKIE_KEYS.DEVICE_AUTH_TOKEN]);

  const handleCheckDeviceAuthCode = async () => {
    if (enteredDeviceAuthCode.length !== PIN_CODE_LENGTH) {
      return;
    }

    // checkDeviceAuthCode成功時のみ画面遷移する
    try {
      await dispatch(
        checkDeviceAuthCode(apiToken, enteredDeviceAuthCode, setCookie),
      );
      history.push('/ds');
    } catch (e) {
      consolelog(e);
    }
  };

  const handleConfirmReissue = async () => {
    await dispatch(reissueDeviceAuthCode(apiToken));
    setShowConfirmationDialog(false);
  };

  return (
    <MainBlock className="ActivationPage">
      <DeviceAuthTitleBar />
      <BodyBlock>
        <InputBlock>
          <InputTitle>
            <FormattedMessage id="deviceAuth.title" />
          </InputTitle>
          <InputBody>
            <TextBlock>
              <p>
                <FormattedMessage id="deviceAuth.description" />
              </p>
              <p>
                <FormattedMessage id="deviceAuth.expiry" />
              </p>
            </TextBlock>
            <PINCodeText>
              <ReissueLink
                onClick={() => {
                  setShowConfirmationDialog(true);
                }}
              >
                <FormattedMessage id="deviceAuth.reissueLink" />
              </ReissueLink>
            </PINCodeText>
            <PINCodeBlock>
              <PINInput
                length={PIN_CODE_LENGTH}
                onComplete={value => setEnteredDeviceAuthCode(value)}
                isError={isDeviceAuthFailed}
              />
              <ErrorMessage>
                {isDeviceAuthFailed && (
                  <FormattedMessage id="deviceAuth.invalidCode" />
                )}
              </ErrorMessage>
            </PINCodeBlock>
            <UpdateButton
              id="ActivateButton"
              onClick={handleCheckDeviceAuthCode}
              disabled={enteredDeviceAuthCode.length !== PIN_CODE_LENGTH}
            >
              <FormattedMessage id="deviceAuth.activateButton" />
            </UpdateButton>
          </InputBody>
        </InputBlock>
      </BodyBlock>
      {showConfirmationDialog && (
        // TODO: i18n対応
        <ConfirmationDialog
          headerText="認証コード再発行"
          messageText="発行済みのコードは失効されますがよろしいですか？"
          onCancel={() => {
            setShowConfirmationDialog(false);
          }}
          onConfirm={handleConfirmReissue}
          confirmButtonText="再発行"
          confirmButtonColor={ColorSF2.navyBlue}
        />
      )}
      <UserPrompt />
    </MainBlock>
  );
};

export default DeviceAuthPage;
